module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahip47-8971554a18ead5af2c92beadffcc76fc.jpg";